/* eslint-disable @typescript-eslint/indent */
import React, { useContext, useEffect, useState } from 'react';
import { campusEdgeCourseId } from '@/utils/helper/helperFunction';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { ICategory } from '@pwskills/rachnaui/components/Navbar/Navbar.types';
import { IError } from '@/interfaces/common';
import HomePage from '@/api/homePage';
import { COURSE_PURCHASE_TYPE } from '@/utils/common/common.constants';
import ProgramOutcomes from '../common/CourseDescriptionPage/ProgramOutcomes';
import KeyCourseElements from './KeyCourseElements';
// import MaterTheseTools from './MasterTheseTools';
import GetCertified from '../common/CourseDescriptionPage/GetCertified';
import GetConnected from '../common/GetConnected';
import SuccessStories from './SuccessStories';
import ProjectSection from '../common/CourseDescriptionPage/ProjectSection';
import NavHeaderSection from '../common/CourseDescriptionPage/NavHeaderSection';
import Faq from '../common/CourseDescriptionPage/Faq';
import CourseCurriculum from '../common/CourseDescriptionPage/CourseCurriculum';
import PlansSection from '../common/CourseDescriptionPage/PlansSection';
import StillConfusedStrip from '../common/CourseDescriptionPage/StillConfusedStrip';
import SEOSection from '../common/CourseDescriptionPage/SEOSection';
import OurAchieversPlacedAt from './OurAchieversPlacedAt';
import Hero from './Hero';
import AlumniTestimonialTextType from '../common/CourseDescriptionPage/AlumniTestimonialTextType';
import AlumniTestimonialTileType from '../common/CourseDescriptionPage/AlumniTestimonialTileType';
import BaseLayout from '../common/BaseLayout';
import { LeadCaptureEnquiryType, ModalType } from '../../interfaces/leadCapture.enum';
import OurMentors from '../HomePageRevamp/Mentors';
import LeadFormModal2 from '../common/LeadForm/LeadFormModal2';
import AboutProgram from './AboutProgram';

const CourseDescriptionPageProfessional = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const courseMetaDetails = courseDetails?.courseMetaDetails;

  const [categoryData, setCategoryData] = useState<ICategory[]>([]);
  const fetchCompanyAndFaqsDetails = async () => {
    try {
      const catchResponse = await HomePage.getCompanyAndFaqs();

      if (catchResponse) {
        const categoryDetails = catchResponse?.data?.categories;
        setCategoryData(categoryDetails);
      }
    } catch (error: unknown) {
      // eslint-disable-next-line no-console
      console.error((error as IError)?.error);
    }
  };

  useEffect(() => {
    fetchCompanyAndFaqsDetails();
  }, []);
  return (
    <div className="relative">
      <BaseLayout category={categoryData} isProfessionalTheme pageName="course_description">
        <NavHeaderSection isCampusEdgeCourseDescription darkTheme />
        <Hero isArmature={false} />
        <AboutProgram isArmature={false} />
        {courseMetaDetails?.enableAboutCourse && <ProgramOutcomes isArmature={false} />}
        {courseMetaDetails?.enableCourseOffering && <KeyCourseElements />}
        {/* <OnboardingProcess /> */}
        {courseMetaDetails?.enableCurriculum && <CourseCurriculum isAmateur={false} />}
        {courseMetaDetails?.enableProjectGallery && <ProjectSection isAmateur={false} />}
        {/* {courseMetaDetails?.enableCourseInstructor && <OurMentors isAmateur={false} />} */}
        {courseMetaDetails?.enableCourseInstructor && <OurMentors isAmateur={false} />}
        {/*  show success story only when its enable and length is greater than 0 */}
        {courseMetaDetails?.enableSuccessStories &&
          courseMetaDetails?.successStories &&
          courseMetaDetails?.successStories?.length > 0 && (
            <>
              <SuccessStories />
              <OurAchieversPlacedAt />
            </>
          )}
        {/*  show plan section only when its enable and length is greater than 0 */}
        {courseDetails?.coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN &&
          courseMetaDetails?.coursePlansDetails &&
          courseMetaDetails?.coursePlansDetails?.length > 0 && <PlansSection isAmateur={false} />}

        {/* show still confused strip fro plan type course only */}
        {courseDetails?.coursePurchaseType === COURSE_PURCHASE_TYPE.PLAN &&
          courseMetaDetails?.coursePlansDetails &&
          courseMetaDetails?.coursePlansDetails?.length > 0 && <StillConfusedStrip />}

        {courseMetaDetails?.enableCertificate && <GetCertified isAmateur={false} />}
        {courseMetaDetails?.counsellingStripOne && (
          <GetConnected
            isConfused={false}
            title="Talk to Our Counsellor"
            subTitle="Get Expert Advice our Counsellor will reach within"
            courseId={campusEdgeCourseId}
            buttonText="Get Connected"
            img="/images/courseDescription/get-in-touch.svg"
            msgLineOne="We Got Your Response."
            msgLineTwo="Our Counsellor will reach out soon"
            type="ConnectWithCounsellor"
            enquiryType={LeadCaptureEnquiryType.GET_IN_TOUCH}
            enquiryTypeNPF="Get in Touch"
            pageName="course_description"
          />
        )}

        {courseMetaDetails?.enableAlumniTestimonials &&
          courseMetaDetails?.testimonials &&
          courseMetaDetails?.testimonials.length > 0 && (
            <>
              {courseMetaDetails?.alumniTestimonial?.type === 'TILE' && (
                <AlumniTestimonialTileType isAmateur={false} />
              )}
              {courseMetaDetails?.alumniTestimonial?.type === 'TEXT' && (
                <AlumniTestimonialTextType isAmateur={false} />
              )}
            </>
          )}
        {courseMetaDetails?.enableSEO && <SEOSection isAmateur={false} />}
        {courseMetaDetails?.counsellingStripTwo && (
          <GetConnected
            isConfused
            title="Still Confused?"
            subTitle="Get Connected to our experts and know what's best for you."
            courseId={campusEdgeCourseId}
            buttonText="Get Connected"
            img="/images/courseDescription/get-in-touch.svg"
            msgLineOne="We Got Your Response."
            msgLineTwo="Our Counsellor will reach out soon"
            type="ConnectWithCounsellor"
            enquiryType={LeadCaptureEnquiryType.GET_IN_TOUCH}
            enquiryTypeNPF="Get in Touch"
            pageName="course_description"
          />
        )}
        <Faq />
        <LeadFormModal2
          buttonText="Next"
          enquiryTypeNPF={LeadCaptureEnquiryType.COURSE_DESCRIPTION_LEADFORM}
          modalType={ModalType.LEAD_FORM}
          pageName="course_description"
        />
      </BaseLayout>
    </div>
  );
};

export default CourseDescriptionPageProfessional;
